
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import FolderStructure from './FolderStructure'
import OrganisationOverview from './OrganisationOverview'
import JsonDebug from '../ui-elements/JsonDebug'

type Props = {
}


function Dashboard({
}: Props) {

    const { tableData } = useContext(GlobalContext)

    return <div className={`w-full flex flex-col items-center justify-center gap-6`}>
        <h3 className={`text-4xl font-brandblue font-righteous`}>Dashboard</h3>
        <div className={`w-full flex md:flex-row flex-col gap-2 items-start`}>
            <FolderStructure />
            <OrganisationOverview />
        </div>


    {/* <JsonDebug jsonobject={tableData.Organisations} /> */}
    </div>
}

export default Dashboard